import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-custom-submit-button',
	templateUrl: './custom-submit-button.component.html',
	styleUrls: ['./custom-submit-button.component.scss'],
})
export class CustomSubmitButtonComponent implements OnInit {
	@Input() id: string;
	@Input() name: string;
	@Input() submitting: boolean;
	@Input() block: boolean;
	@Input() size: string;
	@Input() minWidth: number;
	@Input() type: 'primary' | 'secondary' | 'tertiary' | 'red' | 'decline' = 'primary';
	@Input() disabled: boolean;
	@Output() submitForm: EventEmitter<any> = new EventEmitter();

	constructor() {}

	ngOnInit(): void {}
}
